import * as React from "react";

function Marketo(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} viewBox="0 0 26 26" {...props}><path fill="#5C4C9F" d="M15,0 L15,24 L21,19.1144131 L21,3.33432392 L15,0 Z M11.979579,18.7578009 L7,20.9153046 L7,2.08618128 L11.979579,3.54829123 L11.979579,18.7578009 Z M0,18.205052 L4,17.2065379 L4,5.18870728 L0.0188679245,4.58246657 L0,18.205052 Z" transform="translate(3 1)" /></svg>;
}

export default Marketo;